// @ts-nocheck
import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from "react-query";
import { entitiesNames } from "../../types";
import { Timeline } from "../../../../cuba/entities/base/tsadv_Timeline";
import { $api, coderParams } from "../../api";
import { TimeLineComment } from "../../../../cuba/entities/base/tsadv_TimeLineComment";
import { PostRequestResponse } from "./util";
import { TimeLineLike } from "../../../../cuba/entities/base/tsadv_TimeLineLike";
import moment from "moment";

const fetchTimeLine = async (): Promise<Timeline[]> => {
  // const { id } = params;
  const conditionsTimeLine = [
    {
      property: "publishedDate",
      operator: "<=",
      value: moment().toISOString(),
    },
  ];
  const encodedParams = coderParams("timeline.edit", conditionsTimeLine);
  const { data } = await $api.get<Timeline[]>(
    `/entities/${entitiesNames.timeline}/search?` + encodedParams,
  );
  return data.sort((a: Timeline, b: Timeline) => {
    const dateA: any = moment(a.publishedDate);
    const dateB: any = moment(b.publishedDate);
    return dateB - dateA;
  });
};

export const useTimeLine = (): UseQueryResult<Timeline[], Error> => {
  return useQuery("timeLineQuery", fetchTimeLine, {
    refetchOnWindowFocus: false,
  });
};

const postLoadTimeLineComment = async (
  comment: TimeLineComment,
): Promise<PostRequestResponse> => {
  const { data } = await $api.post<PostRequestResponse>(
    `/entities/${entitiesNames.timeLineComment}`,
    { ...comment },
  );
  return data;
};

export const useLoadTimeLineComment = (): UseMutationResult<
  PostRequestResponse,
  Error
> => {
  return useMutation(postLoadTimeLineComment);
};

const fetchTimeLineComment = async (params: {
  id: string;
}): Promise<TimeLineComment[]> => {
  const { id } = params;
  const conditionsTimeLine = [
    {
      property: "timeLine.id",
      operator: "=",
      value: id,
    },
  ];
  const encodedParamsTimeLine = coderParams(
    "timeLineComment-view",
    conditionsTimeLine,
  );
  const { data } = await $api.get<TimeLineComment[]>(
    `/entities/${entitiesNames.timeLineComment}/search?` +
      encodedParamsTimeLine,
  );
  return data;
};

export const useTimeLineComment = (params: {
  id: string;
}): UseQueryResult<TimeLineComment[], Error> => {
  return useQuery(
    ["timeLineCommentQuery", params],
    () => fetchTimeLineComment(params),
    { refetchOnWindowFocus: false },
  );
};

const fetchTimeLineLike = async (params: {
  id: string;
}): Promise<TimeLineLike[]> => {
  const { id } = params;
  const conditionsTimeLine = [
    {
      property: "timeline.id",
      operator: "=",
      value: id,
    },
  ];
  const encodedParamsTimeLine = coderParams(
    "timeLineLike-view",
    conditionsTimeLine,
  );
  const { data } = await $api.get<TimeLineLike[]>(
    `/entities/${entitiesNames.timeLineLike}/search?` + encodedParamsTimeLine,
  );
  return data;
};

export const useTimeLineLike = (params: {
  id: string;
}): UseQueryResult<TimeLineLike[], Error> => {
  return useQuery(
    ["timeLineLikeQuery", params],
    () => fetchTimeLineLike(params),
    { refetchOnWindowFocus: false },
  );
};

const postLoadTimeLinLike = async (
  likeObject: TimeLineLike,
): Promise<PostRequestResponse> => {
  const { data } = await $api.post<PostRequestResponse>(
    `/entities/${entitiesNames.timeLineLike}`,
    { ...likeObject },
  );
  return data;
};

export const useLoadTimeLineLike = (
  onSuccess: () => void,
): UseMutationResult<PostRequestResponse, Error> => {
  return useMutation(postLoadTimeLinLike, { onSuccess });
};

const deleteLoadTimeLineLike = async (
  id: string,
): Promise<PostRequestResponse> => {
  const { data } = await $api.delete<any>(
    `/entities/${entitiesNames.timeLineLike}/${id}`,
  );
  return data;
};

export const useDeleteTimeLineLike = (): UseMutationResult<any, Error, any> => {
  return useMutation(deleteLoadTimeLineLike);
};
